import {Controller} from "@hotwired/stimulus"
import Cleave from "cleave.js";

// Connects to data-controller="formulario"
export default class extends Controller {
  static targets = ["container", "initialAmount", "finalAmount", "rsPercentage"];

  connect() {
    this.initializeCleave();
  }

  agregarFormulario(event) {
    event.preventDefault();
    fetch('/bo/admin/operatorinfos/add_form')
      .then(response => response.text())
      .then(html => {
        this.containerTarget.insertAdjacentHTML('beforeend', html);
        this.initializeCleave();
      })
      .catch(error => console.error(error));
  }

  agregarFormularioExplorer(event) {
    event.preventDefault();
    fetch('/bo/explorer/operatorinfos/add_form')
      .then(response => response.text())
      .then(html => {
        this.containerTarget.insertAdjacentHTML('beforeend', html);
        this.initializeCleave();
      })
      .catch(error => console.error(error));
  }

  agregarFormularioRenewal(event) {
    event.preventDefault();
    fetch('/bo/admin/renewal_histories/add_form')
      .then(response => response.text())
      .then(html => {
        this.containerTarget.insertAdjacentHTML('beforeend', html);
        this.initializeCleave();
      })
      .catch(error => console.error(error));
  }

  eliminarFormulario(event) {
    event.preventDefault();
    let elementoAEliminar = event.currentTarget.closest('.m-2');
    if (elementoAEliminar) {
      const campoDestroy = elementoAEliminar.querySelector('input[name*="[_destroy]"]');
      if (campoDestroy) {
        campoDestroy.value = "1";
      }

      elementoAEliminar.style.display = 'none';
    }
  }

  initializeCleave() {
    const cleaveTargets = [
      "initialAmount", "finalAmount", "rsPercentage"
    ];

    cleaveTargets.forEach(targetName => {
      const targetElements = this.containerTarget.querySelectorAll(`[data-formulario-target="${targetName}"]`);

      targetElements.forEach(targetElement => {
        // Store the current value and convert decimal point to comma if needed
        const currentValue = targetElement.value;
        const formattedValue = currentValue ? currentValue.replace('.', ',') : '';
        
        new Cleave(targetElement, {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.'
        });
        
        // Set the formatted value after Cleave initialization
        if (formattedValue) {
          targetElement.value = formattedValue;
        }
      });
    });
  }
}
